import React from 'react'
import DatePicker from 'react-datepicker'
import 'react-datepicker/dist/react-datepicker.css'
import { Input } from '.'

export default ({ placeholder, size, withTime, value, onChange }) => {
  return (
    <DatePicker
      placeholderText={placeholder ?? `Tap to select a date${withTime ? ' and time' : ''}...`}
      showTimeSelect={withTime}
      showMonthDropdown
      showYearDropdown
      dropdownMode='select'
      todayButton='Today'
      dateFormat={withTime ? 'dd/MM/yyyy HH:mm' : 'dd/MM/yyyy'}
      timeIntervals={withTime ? 60 : null}
      selected={value ? new Date(value) : null}
      onChange={onChange}
      customInput={<Input size={size} />}
    />
  )
}
